import { z } from 'zod';
import { RedirectParams } from './freemium-redirect-service';

const ParamsSchema = z.object({
  modality: z.string().default(''),
  redirect_to: z.string().default(''),
  subject: z.string().default(''),
  upgrade: z.boolean().default(false),
});

export function validateParams(params: URLSearchParams): RedirectParams {
  const queryParamsObject: { [key: string]: string | boolean } = {};
  for (const [key, value] of params.entries()) {
    if (key === 'upgrade') {
      queryParamsObject[key] = value === 'true' ? true : false;
      continue;
    }
    queryParamsObject[key] = value;
  }
  return ParamsSchema.parse(queryParamsObject) as RedirectParams;
}
